// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1SXKD","resendInfoText":"OnGoingPaymentBox_resendInfoText__LOp1Q"};